export default {"src":"/_next/static/media/live_serach.2ce672ae.svg","height":284,"width":284};